import { ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase/firebaseConfig";

const MAX_BYTES = 50 * 1024 * 1024; // matches functions-drive settings.maxUploadMb
const PDF_MIME = "application/pdf";

/**
 * Upload a purchase-agreement PDF to the per-user holding path in Firebase
 * Storage. The onDealCreate Cloud Function trigger reads from here, uploads
 * to Drive, and deletes the object.
 *
 * @param {string} uid - Firebase Auth uid; used to scope the storage path.
 * @param {File} file - The PDF File from a file input.
 * @returns {Promise<{ storagePath: string, originalName: string }>}
 */
export async function uploadPurchaseAgreementToStorage(uid, file) {
  if (!file) throw new Error("No file provided");
  if (file.type !== PDF_MIME) {
    throw new Error("Purchase agreement must be a PDF");
  }
  if (file.size > MAX_BYTES) {
    throw new Error(
      `Purchase agreement is too large (${(file.size / 1024 / 1024).toFixed(1)} MB; max 50 MB)`
    );
  }

  const ts = Date.now();
  const rand = Math.random().toString(36).slice(2, 10);
  const storagePath = `pending-purchase-agreements/${uid}/${ts}-${rand}.pdf`;

  await uploadBytes(ref(storage, storagePath), file);
  return { storagePath, originalName: file.name };
}
